export const EXTERNAL_LISTING_TRUST_BOUNDARY =
  'StageCrew does not verify every external listing or guarantee that it is legitimate, still open, or will lead to work. Confirm the employer, pay, requirements, and application destination on the original website.';

export const EXTERNAL_APPLICATION_HANDOFF =
  'You are leaving StageCrew. StageCrew does not submit this application or contact the employer for you.';

export const EXTERNAL_EMPLOYER_REVIEW_HANDOFF =
  'You are leaving StageCrew to review the original listing.';

export function getExternalDestinationHost(value: unknown): string | null {
  if (typeof value !== 'string' || !value.trim()) return null;

  try {
    const parsed = new URL(value);
    if (
      !['http:', 'https:'].includes(parsed.protocol)
      || parsed.username
      || parsed.password
      || !parsed.host
    ) {
      return null;
    }

    const normalizedHost = parsed.host.toLowerCase();
    return normalizedHost.startsWith('www.') ? normalizedHost.slice(4) : normalizedHost;
  } catch {
    return null;
  }
}
